import {LocaleType} from '../../locale/type';
import {Locale} from '../generated/types';

export function createLocaleType(locale: LocaleType) {
  return LocaleTypeMap[locale];
}

const LocaleTypeMap: {[key in LocaleType]: Locale} = {
  ko: Locale.Ko,
  en: Locale.En,
  th: Locale.Th,
};
